import React, { Component } from 'react';
import '../css/validations.css'

const VALIDATE_FORMATS = {    
    Address: /^[A-zA-z0-9-ñÑ&.\_\-\s]{1,50}$/,
    Street: /^[A-Za-z0-9-ñÑ&.,#\s]{1,100}$/,
    Block: /^[A-zA-z0-9-ñÑ&.,\s]{1,100}$/,
    City: /^[A-zA-z0-9-ñÑ&.,\s]{1,100}$/,
    ZipCode: /^\d{5,5}$/,
}

class NewAddressModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            validations: { 
                Address: 0,
                Street: 0,
                Block: 0,
                City: 0,
                ZipCode: 0,
                TaxCode: 0,
                County: 0,
            }
        };
    }
    RefreshModel = async (addressModel) => {
        const { DetailPartnerTools } = this.props
        await DetailPartnerTools.RefreshAddressModel(addressModel);
    }

    changeFieldModel = async (model, key, value) => {
        let { validations } = this.state;
        model[key] = value;
        validations[key] = 0;
        this.setState({ validations });
        this.RefreshModel(model);
    };
    
    validateFieldModel = (model, key, type) => {
        let { validations } = this.state;
        const value = model[key];
        switch (type) {
            case 0:
                if (value && value !== '') {
                    if(VALIDATE_FORMATS[key].test(value)) { validations[key] = 0; }
                    else  { validations[key] = 2; }
                } else { validations[key] = 1; }
                break;
            case 1:
                if (value && value !== '--') { validations[key] = 0; } 
                else { validations[key] = 1; }
                break;
            default:
                break;
        }
        
        this.setState({ validations });
        return validations[key] === 0;
    };

    ValidateAll = async (action, lock) => {
        const { DetailPartnerTools } = this.props;
        const { validations } = this.state;
        DetailPartnerTools.addressModel.Country = 'MX';
        await this.RefreshModel(DetailPartnerTools.addressModel);
        this.validateFieldModel(DetailPartnerTools?.addressModel, 'Address', 0);
        this.validateFieldModel(DetailPartnerTools?.addressModel, 'Street', 0);
        this.validateFieldModel(DetailPartnerTools?.addressModel, 'Block', 0);
        this.validateFieldModel(DetailPartnerTools?.addressModel, 'City', 0);
        this.validateFieldModel(DetailPartnerTools?.addressModel, 'ZipCode', 0);
        if (DetailPartnerTools.pointer && Number(DetailPartnerTools.pointer) === 1) {
            this.validateFieldModel(DetailPartnerTools?.addressModel, 'TaxCode', 1);
        }
        this.validateFieldModel(DetailPartnerTools?.addressModel, 'County', 1);

        const validation = (validations.Address + validations.Street + validations.Block + validations.City + 
                            validations.ZipCode + validations.TaxCode + validations.County) === 0;
        if (validation && lock) {
            action();
        }
    }

    ResetValidations = async () => {
        const { DetailPartnerTools } = this.props;
        DetailPartnerTools.addressModel = DetailPartnerTools.AuxAddressModel;
        await this.RefreshModel(DetailPartnerTools.addressModel);

        this.setState({
            validations: { 
                Address: 0,
                Street: 0,
                Block: 0,
                City: 0,
                ZipCode: 0,
                TaxCode: 0,
                County: 0,
            }
        });
    }

    render() {
        const { DetailPartnerTools, states, countries } = this.props
        const { validations } = this.state;

        return (
            <div>
                <div className="modal fade" id="newAddressModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="newAddressModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body">
                                <div className="container" >
                                    <h4>{(DetailPartnerTools && DetailPartnerTools.Action) && (DetailPartnerTools.Action === 1) ? 'Nueva' : DetailPartnerTools.Action === 2 ? 'Editar' : ''} dirección</h4>
                                    <form>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-group" id="grupo__addressCode1">
                                                    <label htmlFor="firstName">Identificador de dirección</label>
                                                    <div className="form__group-input">
                                                        <input
                                                            type="text"
                                                            className={`form-control form__input ${validations.Address !== 0 ? 'form__group-incorrect' : ''}`}
                                                            placeholder="Casa, trabajo, etc..."
                                                            id='addressCode1'
                                                            disabled={((DetailPartnerTools && DetailPartnerTools.Action && DetailPartnerTools.Action === 2)) ? true : false}
                                                            value={DetailPartnerTools && DetailPartnerTools.addressModel ? DetailPartnerTools.addressModel.Address : ''}
                                                            onChange={(event) => this.changeFieldModel(DetailPartnerTools?.addressModel, 'Address', event.target.value)}
                                                            onBlur={ () => this.validateFieldModel(DetailPartnerTools?.addressModel, 'Address', 0) }
                                                        />
                                                        { validations.Address !== 0 && <i className="form__validation-state fa fa-times-circle form__group-incorrect"></i> }
                                                    </div>
                                                    <div className="form-group formulario__grupo" id="grupo__addressCode1">
                                                        { validations.Address === 1 && <p className="form__input-error-active" style={{ marginTop: "-1px" }}>No puede ir vacío</p> }
                                                        { validations.Address === 2 && <p className="form__input-error-active" style={{ marginTop: "-1px" }}>Longitud máxima: 50 caracteres (solo letras y/o números)</p> }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="form-group" id="grupo__street1">
                                                    <label htmlFor="firstName">Calle y Número</label>
                                                    <div className="form__group-input">
                                                        <input
                                                            type="text"
                                                            className={`form-control form__input ${validations.Street !== 0 ? 'form__group-incorrect' : ''}`}
                                                            placeholder="Calle y Número"
                                                            id='street1'
                                                            value={DetailPartnerTools && DetailPartnerTools.addressModel ? DetailPartnerTools.addressModel.Street : ''}
                                                            onChange={(event) => this.changeFieldModel(DetailPartnerTools?.addressModel, 'Street', event.target.value)}
                                                            onBlur={ () => this.validateFieldModel(DetailPartnerTools?.addressModel, 'Street', 0) }
                                                        />
                                                        { validations.Street !== 0 && <i className="form__validation-state fa fa-times-circle form__group-incorrect"></i> }
                                                    </div>
                                                    <div className="form-group formulario__grupo" id="grupo__street1">
                                                        { validations.Street === 1 && <p className="form__input-error-active" style={{ marginTop: "-1px" }}>No puede ir vacío</p> }
                                                        { validations.Street === 2 && <p className="form__input-error-active" style={{ marginTop: "-1px" }}>Longitud máxima: 100 caracteres (solo letras y/o números)</p> }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-group formulario__grupo" id="grupo__block1">
                                                    <label htmlFor="cardCode">Colonia</label>
                                                    <div className="form__group-input">
                                                        <input
                                                            type="text"
                                                            className={`form-control form__input ${validations.Block !== 0 ? 'form__group-incorrect' : ''}`}
                                                            placeholder="Colonia"
                                                            id='block1'
                                                            value={DetailPartnerTools && DetailPartnerTools.addressModel ? DetailPartnerTools.addressModel.Block : ''}
                                                            onChange={(event) => this.changeFieldModel(DetailPartnerTools?.addressModel, 'Block', event.target.value)}
                                                            onBlur={ () => this.validateFieldModel(DetailPartnerTools?.addressModel, 'Block', 0) }
                                                        />
                                                        { validations.Block !== 0 && <i className="form__validation-state fa fa-times-circle form__group-incorrect"></i> }
                                                    </div>
                                                    <div className="form-group formulario__grupo">
                                                        { validations.Block === 1 && <p className="form__input-error-active" style={{ marginTop: "-1px" }}>No puede ir vacío</p> }
                                                        { validations.Block === 2 && <p className="form__input-error-active" style={{ marginTop: "-1px" }}>Longitud máxima: 100 caracteres (solo letras y/o números)</p> }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-group formulario__grupo" id="grupo__city1">
                                                    <label htmlFor="city1">Ciudad</label>
                                                    <div className="form__group-input">
                                                        <input
                                                            type="text"
                                                            className={`form-control form__input ${validations.City !== 0 ? 'form__group-incorrect' : ''}`}
                                                            placeholder="Ciudad"
                                                            id='city1'
                                                            value={DetailPartnerTools && DetailPartnerTools.addressModel ? DetailPartnerTools.addressModel.City : ''}
                                                            onChange={(event) => this.changeFieldModel(DetailPartnerTools?.addressModel, 'City', event.target.value)}
                                                            onBlur={ () => this.validateFieldModel(DetailPartnerTools?.addressModel, 'City', 0) }
                                                        />
                                                        { validations.City !== 0 && <i className="form__validation-state fa fa-times-circle form__group-incorrect"></i> }
                                                    </div>
                                                    <div className="form-group formulario__grupo" id="grupo__city1">
                                                        { validations.City === 1 && <p className="form__input-error-active" style={{ marginTop: "-1px" }}>No puede ir vacío</p> }
                                                        { validations.City === 2 && <p className="form__input-error-active" style={{ marginTop: "-1px" }}>Longitud máxima: 100 caracteres (solo letras y/o números)</p> }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-group formulario__grupo" id="grupo__pc">
                                                    <label htmlFor="pc1">Código postal</label>
                                                    <div className="form__group-input">
                                                        <input
                                                            type="text"
                                                            className={`form-control form__input ${validations.ZipCode !== 0 ? 'form__group-incorrect' : ''}`}
                                                            placeholder="C.P."
                                                            id="pc"
                                                            value={DetailPartnerTools && DetailPartnerTools.addressModel ? DetailPartnerTools.addressModel.ZipCode : ''}
                                                            onChange={(event) => this.changeFieldModel(DetailPartnerTools?.addressModel, 'ZipCode', event.target.value)}
                                                            onBlur={ () => this.validateFieldModel(DetailPartnerTools?.addressModel, 'ZipCode', 0) }
                                                        />
                                                        { validations.ZipCode !== 0 && <i className="form__validation-state fa fa-times-circle form__group-incorrect"></i> }
                                                    </div>
                                                    <div className="form-group formulario__grupo" id="grupo__pc">
                                                        { validations.ZipCode === 1 && <p className="form__input-error-active" style={{ marginTop: "-1px" }}>No puede ir vacío</p> }
                                                        { validations.ZipCode === 2 && <p className="form__input-error-active" style={{ marginTop: "-1px" }}>Son 5 números</p> }
                                                    </div>
                                                </div>
                                            </div>
                                            {DetailPartnerTools.pointer && Number(DetailPartnerTools.pointer) === 1 &&
                                                <div className="col-6" id="grupo__taxId">
                                                    <div className="form-group form__group-input">
                                                        <label htmlFor="taxId">Indicador de impuestos</label>
                                                        <select
                                                            name="stateS"
                                                            className={`form-control form__input ${validations.TaxCode !== 0 ? 'form__group-incorrect' : ''}`}
                                                            id='taxId'
                                                            value={DetailPartnerTools && DetailPartnerTools.addressModel ? DetailPartnerTools.addressModel.TaxCode : ''}
                                                            onChange={(event) => this.changeFieldModel(DetailPartnerTools?.addressModel, 'TaxCode', event.target.value)}
                                                            onBlur={ () => this.validateFieldModel(DetailPartnerTools?.addressModel, 'TaxCode', 1) }
                                                        >
                                                            <option value="--">Seleccione una opcion</option>
                                                            {DetailPartnerTools.taxes && DetailPartnerTools.taxes.length > 0 && DetailPartnerTools.taxes.map((taxItem) => (
                                                                <option key={taxItem.Code} value={taxItem.Code} >
                                                                    {taxItem.Code} .- {taxItem.Name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        { validations.TaxCode === 1 && <p className="form__input-error-active" style={{ marginTop: "-1px" }}>Elija un indicador</p> }
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                        <div className="row">
                                            <div className="col-6" id="grupo__state1">
                                                <div className="form-group form__group-input">
                                                    <label htmlFor="state1">Estado </label>
                                                    <select
                                                        name="stateS"
                                                        className={`form-control form__input ${validations.County !== 0 ? 'form__group-incorrect' : ''}`}
                                                        id='state1'
                                                        value={DetailPartnerTools && DetailPartnerTools.addressModel ? DetailPartnerTools.addressModel.State : ''}
                                                        onChange={(event) => {
                                                            const state = states.find(({Code}) => Code === event.target.value);
                                                            this.changeFieldModel(DetailPartnerTools?.addressModel, 'County', state?.Name ?? '--');
                                                            this.changeFieldModel(DetailPartnerTools?.addressModel, 'State', state?.Code ?? '--');
                                                        }}
                                                        onBlur={ () => this.validateFieldModel(DetailPartnerTools?.addressModel, 'County', 1) }
                                                    >
                                                        <option value="--">Estado</option>
                                                        {states && states.length > 0 && states.map((state) => (
                                                            state.Country === "MX" ?
                                                                <option value={state.Code}> {state.Name} </option> 
                                                                : ""
                                                        ))}
                                                    </select>
                                                    { validations.County === 1 && <p className="form__input-error-active" style={{ marginTop: "-1px" }}>Elija un estado</p> }
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-group formulario__grupo" id="grupo__rfc">
                                                    <label htmlFor="pc">País </label>
                                                    <div className="form__group-input">
                                                        <select
                                                            name="countryB"
                                                            value={DetailPartnerTools && DetailPartnerTools.addressModel ? DetailPartnerTools.addressModel.Country : ''}
                                                            className="form-control form__input"
                                                            onChange={(event) => this.ChangeCountry(event.target.value)}>
                                                            {countries && countries.length > 0 && countries.map((country) => (
                                                                country.Name === "Mexico" ?
                                                                    <option key={country.Code} value={country.Code} >
                                                                        {country.Name}
                                                                    </option> : ""
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <div className="col-sm-12">
                                    <div className="m-2 row">
                                        <button type="button" className="btn-lg btn-secondary col-3 ml-2 mr-4" data-dismiss="modal" data-toggle="modal" data-target="#detailClientModal" onClick={this.ResetValidations}>Cancelar</button>
                                        <button className="btn-lg btn-primary d-block w-100 col-8" onClick={() => this.ValidateAll(() => DetailPartnerTools.SendAddress(), true)} >
                                            {DetailPartnerTools && DetailPartnerTools.Action === 1 ? 'Crear' : DetailPartnerTools.Action === 2 ? 'Guardar edición' : ''}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NewAddressModal;